import { match, P } from 'ts-pattern';

import type { FEATURE } from '~/common/enums/feature.enum';
import { logError } from '~/common/utils/log';

import { getMixpanelDefault } from '../featureFlagSource';
import type { TreatmentWithConfig } from '../types';

export type MixpanelVariant = { key?: string | null; value: unknown };

// toTreatment runs on every render, so a malformed variant is logged once per flag, not per read.
const flagsWithMalformedVariantLogged = new Set<FEATURE>();

const defaultForMalformed = (flag: FEATURE, variant: MixpanelVariant): TreatmentWithConfig => {
  if (!flagsWithMalformedVariantLogged.has(flag)) {
    flagsWithMalformedVariantLogged.add(flag);
    logError(`[feature-flags] Mixpanel variant for ${flag} has no key`, variant);
  }
  return getMixpanelDefault(flag);
};

export const toTreatment = (flag: FEATURE, variant?: MixpanelVariant): TreatmentWithConfig =>
  match(variant)
    .with(P.nullish, () => getMixpanelDefault(flag))
    .with({ value: true }, () => ({ treatment: 'on' }))
    .with({ value: false }, () => ({ treatment: 'off' }))
    .with({ key: P.string.minLength(1), value: P.nullish }, ({ key }) => ({
      treatment: key.toLowerCase(),
    }))
    .with({ key: P.string.minLength(1) }, ({ key, value }) => ({
      treatment: key.toLowerCase(),
      config: value,
    }))
    .otherwise((malformed) => defaultForMalformed(flag, malformed));
